module.exports = __webpack_public_path__ + "img/noDigital.a59ee6fd.png";